import FullPageLoader from "./full-page-laoder";

export default FullPageLoader;
